// @mui material components
import Grid from "@mui/material/Grid";
import { baseURL } from "utils/api";
import axios from "axios";
import MDBox from "components/MDBox";
import { useState } from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse.jsx";
import { useNavigate } from "react-router-dom";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

// Dashboard components

function AddNewShop() {
  // ------------------------------------------ZERO CODE---------------------------------------------------------//
  const [country, setCountry] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleSearchChange = (event) => {
    setCategoryName(event.target.value);
    setSelectedOption("");
    setIsDropdownOpen(!!event.target.value);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setCategoryName("");
    setIsDropdownOpen(false);
  };
  const handleInputChange = (event) => {
    setCategoryName(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        console.log(categoryName);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry(data.data.map((item) => item.categoryName));
          localStorage.setItem("data", JSON.stringify(categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName]);

  const filteredOptions = country.filter((option) =>
    option.toLowerCase().includes(categoryName.toLowerCase())
  );
  // --------------------------------------------FIRST TEXT FIELD---------------------------------------------//
  const [country1, setCountry1] = useState([]);
  const [categoryName1, setCategoryName1] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [homeIndex1, setHomeIndex1] = useState("");
  const handleSearchChange1 = (event) => {
    setCategoryName1(event.target.value);
    setSelectedOption1("");
    setIsDropdownOpen1(!!event.target.value);
  };

  const handleOptionSelect1 = (option) => {
    setSelectedOption1(option);
    setCategoryName1("");
    setIsDropdownOpen1(false);
  };

  const handleInputChange1 = (event) => {
    setCategoryName1(event.target.value);
  };
  const handleInputChangeHome1 = (event) => {
    setHomeIndex1(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      console.log(categoryName1, "categoryName");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName1}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();

        if (data && Array.isArray(data.data)) {
          setCountry1(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName1]);

  const filteredOptions1 = country1.filter((option) =>
    option.toLowerCase().includes(categoryName1.toLowerCase())
  );
  // --------------------------------------SECOND TEXTFIELD------------------------------------------------------//
  const [country2, setCountry2] = useState([]);
  const [categoryName2, setCategoryName2] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);

  const handleSearchChange2 = (event) => {
    setCategoryName2(event.target.value);
    setSelectedOption2("");
    setIsDropdownOpen2(!!event.target.value);
  };

  const handleOptionSelect2 = (option) => {
    setSelectedOption2(option);
    setCategoryName2("");
    setIsDropdownOpen2(false);
  };

  const handleInputChange2 = (event) => {
    setCategoryName2(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName2}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry2(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName2]);

  const filteredOptions2 = country2.filter((option) =>
    option.toLowerCase().includes(categoryName2.toLowerCase())
  );
  // -------------------------------------------THIRD CODE-----------------------------------------------------//
  const [country3, setCountry3] = useState([]);
  const [categoryName3, setCategoryName3] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [isDropdownOpen3, setIsDropdownOpen3] = useState(false);

  const handleSearchChange3 = (event) => {
    setCategoryName3(event.target.value);
    setSelectedOption3("");
    setIsDropdownOpen3(!!event.target.value);
  };

  const handleOptionSelect3 = (option) => {
    setSelectedOption3(option);
    setCategoryName3("");
    setIsDropdownOpen3(false);
  };

  const handleInputChange3 = (event) => {
    setCategoryName3(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName3}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry3(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName3]);

  const filteredOptions3 = country3.filter((option) =>
    option.toLowerCase().includes(categoryName3.toLowerCase())
  );

  // -------------------------------------------FOURTH CODE-----------------------------------------------------//
  const [country4, setCountry4] = useState([]);
  const [categoryName4, setCategoryName4] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [isDropdownOpen4, setIsDropdownOpen4] = useState(false);

  const handleSearchChange4 = (event) => {
    setCategoryName4(event.target.value);
    setSelectedOption4("");
    setIsDropdownOpen4(!!event.target.value);
  };

  const handleOptionSelect4 = (option) => {
    setSelectedOption4(option);
    setCategoryName4("");
    setIsDropdownOpen4(false);
  };

  const handleInputChange4 = (event) => {
    setCategoryName4(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName4}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry4(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName4]);

  const filteredOptions4 = country4.filter((option) =>
    option.toLowerCase().includes(categoryName4.toLowerCase())
  );

  // -------------------------------------------FIFTH CODE-----------------------------------------------------//
  const [country5, setCountry5] = useState([]);
  const [categoryName5, setCategoryName5] = useState("");
  const [selectedOption5, setSelectedOption5] = useState("");
  const [isDropdownOpen5, setIsDropdownOpen5] = useState(false);

  const handleSearchChange5 = (event) => {
    setCategoryName5(event.target.value);
    setSelectedOption5("");
    setIsDropdownOpen5(!!event.target.value);
  };

  const handleOptionSelect5 = (option) => {
    setSelectedOption5(option);
    setCategoryName5("");
    setIsDropdownOpen5(false);
  };

  const handleInputChange5 = (event) => {
    setCategoryName5(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName5}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry5(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName5]);

  const filteredOptions5 = country5.filter((option) =>
    option.toLowerCase().includes(categoryName5.toLowerCase())
  );
  // -------------------------------------------SIXTH CODE-----------------------------------------------------//
  const [country6, setCountry6] = useState([]);
  const [categoryName6, setCategoryName6] = useState("");
  const [selectedOption6, setSelectedOption6] = useState("");
  const [isDropdownOpen6, setIsDropdownOpen6] = useState(false);

  const handleSearchChange6 = (event) => {
    setCategoryName6(event.target.value);
    setSelectedOption6("");
    setIsDropdownOpen6(!!event.target.value);
  };

  const handleOptionSelect6 = (option) => {
    setSelectedOption6(option);
    setCategoryName6("");
    setIsDropdownOpen6(false);
  };

  const handleInputChange6 = (event) => {
    setCategoryName6(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName6}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry6(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName6]);

  const filteredOptions6 = country6.filter((option) =>
    option.toLowerCase().includes(categoryName6.toLowerCase())
  );

  // -------------------------------------------SEVENTH CODE-----------------------------------------------------//
  const [country7, setCountry7] = useState([]);
  const [categoryName7, setCategoryName7] = useState("");
  const [selectedOption7, setSelectedOption7] = useState("");
  const [isDropdownOpen7, setIsDropdownOpen7] = useState(false);

  const handleSearchChange7 = (event) => {
    setCategoryName7(event.target.value);
    setSelectedOption7("");
    setIsDropdownOpen7(!!event.target.value);
  };

  const handleOptionSelect7 = (option) => {
    setSelectedOption7(option);
    setCategoryName7("");
    setIsDropdownOpen7(false);
  };
  const handleInputChange7 = (event) => {
    setCategoryName7(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName7}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry7(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName7]);

  const filteredOptions7 = country7.filter((option) =>
    option.toLowerCase().includes(categoryName7.toLowerCase())
  );
  // -------------------------------------------SEVENTH CODE-----------------------------------------------------//
  const [country8, setCountry8] = useState([]);
  const [categoryName8, setCategoryName8] = useState("");
  const [selectedOption8, setSelectedOption8] = useState("");
  const [isDropdownOpen8, setIsDropdownOpen8] = useState(false);

  const handleSearchChange8 = (event) => {
    setCategoryName8(event.target.value);
    setSelectedOption8("");
    setIsDropdownOpen8(!!event.target.value);
  };

  const handleOptionSelect8 = (option) => {
    setSelectedOption8(option);
    setCategoryName8("");
    setIsDropdownOpen8(false);
  };

  const handleInputChange8 = (event) => {
    setCategoryName8(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName8}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry8(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName8]);

  const filteredOptions8 = country8.filter((option) =>
    option.toLowerCase().includes(categoryName8.toLowerCase())
  );

  // -------------------------------------------NINETH CODE-----------------------------------------------------//
  const [country9, setCountry9] = useState([]);
  const [categoryName9, setCategoryName9] = useState("");
  const [selectedOption9, setSelectedOption9] = useState("");
  const [isDropdownOpen9, setIsDropdownOpen9] = useState(false);

  const handleSearchChange9 = (event) => {
    setCategoryName9(event.target.value);
    setSelectedOption9("");
    setIsDropdownOpen9(!!event.target.value);
  };

  const handleOptionSelect9 = (option) => {
    setSelectedOption9(option);
    setCategoryName9("");
    setIsDropdownOpen9(false);
  };

  const handleInputChange9 = (event) => {
    setCategoryName9(event.target.value);
  };

  useEffect(() => {
    const getCountryData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName9}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry9(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName9]);

  const filteredOptions9 = country9.filter((option) =>
    option.toLowerCase().includes(categoryName9.toLowerCase())
  );

  //---------------------------------------SECOND CODE-SAVE---------------------------------------------------//
  const [homeIndex, setHomeIndex] = useState("");
  //   const handlePost = async (categoryName, homeIndex) => {
  //     try {
  //       const details = {
  //         categoryName: [categoryName],
  //         homeIndex: [homeIndex],
  //       };

  //       console.log(homeIndex, "ssssssssssssssssssssssssssssssssssssssssssssssssssssssssss");
  //       const response = await fetch(
  //         "https://jumunona.onrender.com/admin/categories/createHomePageCategories",
  //         {
  //           method: "POST",
  //           body: JSON.stringify(details),
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       const responseData = await response.json();

  //       if (response.ok) {
  //         console.log("Data posted successfully:", responseData);
  //         setCategoryName("");
  //         setHomeIndex("5");
  //       } else {
  //         console.error("Failed to post data:", responseData);
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };

    // const handlePost = async (categoryName, homeIndex) => {
    //   try {

    //     const details = {
    //       categoryName: [categoryName],
    //       homeIndex: [homeIndex],
    //     };

    //     console.log(homeIndex, "ssssssssssssssssssssssssssss");
    //     console.log(categoryName,"55")
    //     const response = await fetch(
    //       "https://jumunona.onrender.com/admin/categories/createHomePageCategories",
    //       {
    //         method: "POST",
    //         body: JSON.stringify(details),
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     const responseData = await response.json();

    //     if (response.ok) {
    //       console.log("Data posted successfully:", responseData);
    //       setCategoryName("");
    //       setHomeIndex("5");
    //     } else {
    //       console.error("Failed to post data:", responseData);
    //     }
    //   } catch (error) {
    //     console.error("Error:", error);
    //   }
    // };

    const handlePost = async () => {
      try {
        const details = {
          categoryName: [categoryName],
          homeIndex: [homeIndex],
        };
    
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/createHomePageCategories`,
          {
            method: "POST",
            body: JSON.stringify(details),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
    
        const responseData = await response.json();
    
        if (response.ok) {
          console.log("Data posted successfully:", responseData);
          setCategoryName("");
          setHomeIndex("5");
        } else {
          console.error("Failed to post data:", responseData);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    

  const handleInputChanges = (event) => {
    setHomeIndex(event.target.value);
  };

  // -------------------------------GET DATA---------------------------------------------------------------//
  const [indexedData, setIndexedData] = useState([]);
  const [data, setData] = useState([]);
  const [firstCategory, setFirstCategory] = useState("");
  const [firstCategory1, setFirstCategory1] = useState("");
  const [firstCategory2, setFirstCategory2] = useState("");
  const [firstCategory3, setFirstCategory3] = useState("");
  const [firstCategory4, setFirstCategory4] = useState("");
  const [firstCategory5, setFirstCategory5] = useState("");
  const [firstCategory6, setFirstCategory6] = useState("");
  const [firstCategory7, setFirstCategory7] = useState("");
  const [firstCategory8, setFirstCategory8] = useState("");
  const [firstCategory9, setFirstCategory9] = useState("");

  const HomeCategory = [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/getHomeCategories`
        );
        const resp = await result.json();
        setData(resp.data);

        if (resp.data && Array.isArray(resp.data)) {
          const indexedData = resp.data.map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          setIndexedData(indexedData);
          resp.data.forEach((item) => {
            HomeCategory.push(item.categoryName ? item.categoryName : "testEample");
          });

          console.log(HomeCategory, "HomeCategory");
          console.log(HomeCategory[0], "sadasdd");
          console.log(HomeCategory[8], "uuuuuuuuuuuuuuuuuuuuuuuuu");
          if (HomeCategory.length > 0) {
            setFirstCategory(HomeCategory[0]);
            setFirstCategory1(HomeCategory[1]);
            setFirstCategory2(HomeCategory[2]);
            setFirstCategory3(HomeCategory[3]);
            setFirstCategory4(HomeCategory[4]);
            setFirstCategory5(HomeCategory[5]);
            setFirstCategory6(HomeCategory[6]);
            setFirstCategory7(HomeCategory[7]);
            setFirstCategory8(HomeCategory[8]);
            setFirstCategory9(HomeCategory[9]);
          }
          console.log(firstCategory, "first");
          console.log(firstCategory1);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  //   const handleSearchChange = (e) => {
  //     setCategoryName(e.target.value);
  //   };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <div className="flex">
          <label>
            <Link to="/CategoriesList">
              <span
                type="button"
                className="bg-green-500  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
              >
                Categories List
              </span>
            </Link>
          </label>
        </div>
        <form
          style={{
            marginTop: "5%",
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          //   onSubmit={handleUploadStore}
        >
          <div style={{ display: "flex", gap: "100px" }}>
            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption && (
                <input
                  type="text"
                  //   value={ categoryName}
                  defaultValue={firstCategory}
                  onChange={handleSearchChange}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen && !selectedOption && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect(option)}
                        className={selectedOption === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <input
                    type="text"
                    name="categoryName"
                    value={categoryName}
                  />

                  <input
                    type="text"
                    name="homeIndex"
                    value={homeIndex}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />

                  {/* <div>
                    <input
                      type="text"
                      value={categoryName}
                      onChange={handleInputChange}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter homeIndex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>

            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption1 && (
                <input
                  type="text"
                  //   value={categoryName1}
                  defaultValue={firstCategory1}
                  onChange={handleSearchChange1}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen1 && !selectedOption1 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions1.length > 0 ? (
                    filteredOptions1.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect1(option)}
                        className={selectedOption1 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption1 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption1}
                    onChange={(e) => setSelectedOption1(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName1}
                      onChange={handleInputChange1}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter home Index"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>
          </div>

          {/* ------------------------------------------SECOND ROWS-----------------------------------------------------------*/}
          <div style={{ display: "flex", gap: "100px", marginTop: "2%" }}>
            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption2 && (
                <input
                  type="text"
                  //   value={categoryName2}
                  defaultValue={firstCategory2}
                  onChange={handleSearchChange2}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen2 && !selectedOption2 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions2.length > 0 ? (
                    filteredOptions2.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect2(option)}
                        className={selectedOption2 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption2 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption2}
                    onChange={(e) => setSelectedOption2(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName2}
                      onChange={handleInputChange2}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>

            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption3 && (
                <input
                  type="text"
                  //   value={categoryName3}
                  defaultValue={firstCategory3}
                  onChange={handleSearchChange3}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen3 && !selectedOption3 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions3.length > 0 ? (
                    filteredOptions3.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect3(option)}
                        className={selectedOption3 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption3 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption3}
                    onChange={(e) => setSelectedOption3(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName3}
                      onChange={handleInputChange3}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>
          </div>

          {/* ------------------------------------------THIRD ROWS--------------------------------------------------------*/}
          <div style={{ display: "flex", gap: "100px", marginTop: "2%" }}>
            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption4 && (
                <input
                  type="text"
                  //   value={categoryName4}
                  defaultValue={firstCategory4}
                  onChange={handleSearchChange4}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen4 && !selectedOption4 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions4.length > 0 ? (
                    filteredOptions4.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect4(option)}
                        className={selectedOption4 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption4 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption4}
                    onChange={(e) => setSelectedOption4(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName4}
                      onChange={handleInputChange4}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>

            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption5 && (
                <input
                  type="text"
                  //   value={categoryName5}
                  defaultValue={firstCategory5}
                  onChange={handleSearchChange5}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen5 && !selectedOption5 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions5.length > 0 ? (
                    filteredOptions5.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect5(option)}
                        className={selectedOption5 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption5 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption5}
                    onChange={(e) => setSelectedOption5(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName5}
                      onChange={handleInputChange5}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", gap: "100px", marginTop: "2%" }}>
            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption6 && (
                <input
                  type="text"
                  //   value={categoryName6}
                  defaultValue={firstCategory6}
                  onChange={handleSearchChange6}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen6 && !selectedOption6 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions6.length > 0 ? (
                    filteredOptions6.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect6(option)}
                        className={selectedOption6 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption6 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption6}
                    onChange={(e) => setSelectedOption6(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName6}
                      onChange={handleInputChange6}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>

            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption7 && (
                <input
                  type="text"
                  //   value={categoryName7}
                  defaultValue={firstCategory7}
                  onChange={handleSearchChange7}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}

              {isDropdownOpen7 && !selectedOption7 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions7.length > 0 ? (
                    filteredOptions7.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect7(option)}
                        className={selectedOption7 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption7 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption7}
                    onChange={(e) => setSelectedOption7(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName7}
                      onChange={handleInputChange7}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>
          </div>
          {/* ------------------------------------------LAST ROWS--------------------------------------------------------- */}

          <div style={{ display: "flex", gap: "100px", marginTop: "2%" }}>
            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption8 && (
                <input
                  type="text"
                  //   value={categoryName8}
                  defaultValue={firstCategory8}
                  onChange={handleSearchChange8}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}
              {isDropdownOpen8 && !selectedOption8 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions8.length > 0 ? (
                    filteredOptions8.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect8(option)}
                        className={selectedOption8 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption8 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption8}
                    onChange={(e) => setSelectedOption8(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName}
                      onChange={handleInputChange8}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>

            {/* <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption9 && (
                <input
                  type="text"
                  //   value={categoryName9}
                  defaultValue={firstCategory9}
                  onChange={handleSearchChange9}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}
              {isDropdownOpen9 && !selectedOption9 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions9.length > 0 ? (
                    filteredOptions9.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect9(option)}
                        className={selectedOption9 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption9 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption9}
                    onChange={(e) => setSelectedOption9(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <div>
                    <input
                      type="text"
                      value={categoryName9}
                      onChange={handleInputChange9}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChanges}
                      placeholder="Enter homeIndex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div>
                </div>
              )}
            </div> */}

            <div style={{ position: "relative", width: "45%" }}>
              {!selectedOption9 && (
                <input
                  type="text"
                  //   value={categoryName9}
                  defaultValue={firstCategory9}
                  onChange={handleSearchChange9}
                  placeholder="--Search CategoryName--"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    appearance: "none",
                  }}
                />
              )}
              {isDropdownOpen9 && !selectedOption9 && (
                <div
                  className="dropdown"
                  style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                >
                  {filteredOptions9.length > 0 ? (
                    filteredOptions9.map((option, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionSelect9(option)}
                        className={selectedOption9 === option ? "selected" : ""}
                        style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                      >
                        {option}
                      </div>
                    ))
                  ) : (
                    <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                      No results found
                    </div>
                  )}
                </div>
              )}

              {selectedOption9 && (
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={selectedOption9}
                    onChange={(e) => setSelectedOption9(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                    }}
                  />
                  <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, homeIndex)}
                  />
                  {/* <div>
                    <input
                      type="text"
                      value={categoryName9}
                      onChange={handleInputChange9}
                      placeholder="Enter category name"
                    />
                    <input
                      type="text"
                      value={homeIndex}
                      onChange={handleInputChange}
                      placeholder="Enter Homeindex"
                    />
                    <SaveAltOutlinedIcon
                      style={{
                        cursor: "pointer",
                        color: "green",
                      }}
                      onClick={() => handlePost(categoryName, homeIndex)}
                    />
                  </div> */}
                </div>
              )}
            </div>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewShop;
